import { shade } from "polished";
import styled, { css } from "styled-components";

import { colors, globalStyle } from "components";

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.button`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  margin-bottom: 14px;
  h1 {
    font-family: ${globalStyle.fontFamily};
    font-weight: 600;
    font-size: 1rem;
    color: #000;
    text-transform: initial;
  }

  svg {
    color: #7887a9;
  }
  cursor: pointer;
`;

export const Body = styled.div``;

export const ButtonNavigate = styled.button<{ selected: boolean }>`
  width: 100%;
  text-align: start;
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 14px;
  font-family: ${globalStyle.fontFamily};
  cursor: pointer;
  text-transform: inherit;
  text-align: start;
  margin-bottom: 4px;

  &:hover {
    background: ${(props) =>
      props.selected
        ? shade(0.2, colors.default_blue)
        : colors.default_base_grey};
    border-radius: 4px;
  }

  ${(props) =>
    props.selected &&
    css`
      background: ${colors.default_blue};
      color: ${colors.default_base_white};
      font-weight: 600;
      border-radius: 4px;
    `}
`;
